import './CategoryFilter.css';

interface CategoryItem {
  categorySlug: string;
  categoryName: string;
  subCategorySlug: string | null;
  subCategoryName: string | null;
}

interface CategoryFilterProps {
  categories: CategoryItem[];
  selectedCategory: string | null;
  selectedSubCategory: string | null;
  onCategoryChange: (category: string | null) => void;
  onSubCategoryChange: (subCategory: string | null) => void;
}

export function CategoryFilter({
  categories,
  selectedCategory,
  selectedSubCategory,
  onCategoryChange,
  onSubCategoryChange,
}: CategoryFilterProps) {
  // Extract unique categories
  const uniqueCategories = Array.from(
    new Map(categories.map(c => [c.categorySlug, { slug: c.categorySlug, name: c.categoryName }])).values()
  );

  // Extract subcategories for selected category
  const subCategories = selectedCategory
    ? categories
        .filter(c => c.categorySlug === selectedCategory && c.subCategorySlug !== null)
        .map(c => ({ slug: c.subCategorySlug!, name: c.subCategoryName! }))
        .filter((sc, index, self) => self.findIndex(s => s.slug === sc.slug) === index)
    : [];

  const handleCategoryClick = (categorySlug: string) => {
    if (selectedCategory === categorySlug) {
      onCategoryChange(null);
      onSubCategoryChange(null);
    } else {
      onCategoryChange(categorySlug);
      onSubCategoryChange(null);
    }
  };

  const handleSubCategoryClick = (subCategorySlug: string) => {
    if (selectedSubCategory === subCategorySlug) {
      onSubCategoryChange(null);
    } else {
      onSubCategoryChange(subCategorySlug);
    }
  };

  return (
    <div className="category-filter">
      <div className="category-filter__section">
        <span className="category-filter__label">Category:</span>
        <div className="category-filter__buttons">
          <button
            className={`category-filter__button ${selectedCategory === null ? 'category-filter__button--active' : ''}`}
            onClick={() => {
              onCategoryChange(null);
              onSubCategoryChange(null);
            }}
            type="button"
          >
            All
          </button>
          {uniqueCategories.map(cat => (
            <button
              key={cat.slug}
              className={`category-filter__button ${selectedCategory === cat.slug ? 'category-filter__button--active' : ''}`}
              onClick={() => handleCategoryClick(cat.slug)}
              type="button"
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      {subCategories.length > 0 && (
        <div className="category-filter__section">
          <span className="category-filter__label">Subcategory:</span>
          <div className="category-filter__buttons">
            <button
              className={`category-filter__button category-filter__button--sub ${selectedSubCategory === null ? 'category-filter__button--active' : ''}`}
              onClick={() => onSubCategoryChange(null)}
              type="button"
            >
              All
            </button>
            {subCategories.map(subCat => (
              <button
                key={subCat.slug}
                className={`category-filter__button category-filter__button--sub ${selectedSubCategory === subCat.slug ? 'category-filter__button--active' : ''}`}
                onClick={() => handleSubCategoryClick(subCat.slug)}
                type="button"
              >
                {subCat.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
